<script>
import Layout from './layouts/Main.vue'
import ReportFilter from '@/components/ReportsFilter.vue'
import ReportTable from '@/components/ReportsTable.vue'
import { configMethods } from '@/store/helpers'

export default {
	name: 'Reports',
	page: {
		title: `${
			process.env.VUE_APP_ENV !== 'prd'
				? process.env.VUE_APP_ENV.toUpperCase()
				: ''
		} Reports`,
		meta: [
			{
				name: 'content',
				description: 'Generate reports'
			}
		]
	},
	components: {
		Layout,
		ReportFilter,
		ReportTable
	},
	mounted() {
		this.fetchClients()
	},
	methods: {
		...configMethods
	}
}
</script>

<template>
	<layout>
		<div class="row">
			<div class="col mt-3">
				<report-filter />
			</div>
		</div>
		<div class="row">
			<div class="col">
				<report-table />
			</div>
		</div>
	</layout>
</template>
